import * as z from 'zod';

export type PricingPlanObjectFormSchemaValues = z.infer<typeof pricingPlanObjectFormSchema>;
export const pricingPlanObjectFormSchema = z.object({
    valid_from: z.string(),
    valid_to: z.string().optional().nullable(),
    pricing_plan_identity: z.string(),
    site: z.string().optional(),
    zone: z.string().optional(),
    gateway: z.string().optional(),
});